import Vue from 'vue'

const EventBusKey = {
  /** 翻译相关触发 */
  TRANSLATE: 'TRANSLATE',
  KNIVES_ERR: 'KNIVES_ERR', // 用于临时处理找不到刀
  OTHER_KNIVES_ERR: 'OTHER_KNIVES_ERR', // 另外的刀错误信息
  PREFERENCES_UPDATE: 'PREFERENCES_UPDATE', // 偏好设置更新
  NOTICE_USER_RELOAD: 'NOTICE_USER_RELOAD', // 通知用户需要重新加载
  SELECT_MENU_ITEM: 'SELECT_MENU_ITEM', // 另外的刀错误信息
  REFRESH_MATERIAL_LIST: 'REFRESH_MATERIAL_LIST', // 刷新开料清单
  CUSTOM_FOLDER_DRAG_EVENT: 'CUSTOM_FOLDER_DRAG_EVENT', // 自定义文件夹拖拽相关事件触发
  /**
   * 创建排版任务后触发飞行动效（paibanSetting -> g-paiban-task-fly）
   * payload: { fromSelector?, toSelector?, taskBatch?, statusText? }
   */
  PAIBAN_TASK_FLY: 'PAIBAN_TASK_FLY',
  /** 排版任务卡片飞行动效结束（g-paiban-task-fly -> paibanSetting） */
  PAIBAN_TASK_FLY_END: 'PAIBAN_TASK_FLY_END',
}

export { EventBusKey }
export default new Vue()
